import { useLogged } from "hook/useLogged";
import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ButtonTryPlatform = () => {
  // -------------------------- VAR -----------------------------
  const { logged } = useLogged();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLogged = () => {
    if (logged) {
      return (
        <>
          <a
            href="/bailiff"
            className="bg-primary-700 hover:bg-primary-900 group inline-flex transform items-center gap-3 rounded-xl px-10 py-4 text-lg font-bold text-white transition-all hover:-translate-y-1 hover:shadow-lg"
          >
            <span>Thử và đồng hành cùng chúng tôi!</span>
            <FaArrowRight className="transition-transform group-hover:translate-x-1" />
          </a>
        </>
      );
    }
  };

  const renderUnLogged = () => {
    if (!logged) {
      return (
        <>
          <a
            href="/login"
            className="bg-primary-700 hover:bg-primary-900 group inline-flex transform items-center gap-3 rounded-xl px-10 py-4 text-lg font-bold text-white transition-all hover:-translate-y-1 hover:shadow-lg"
          >
            <span>Thử và đồng hành cùng chúng tôi!</span>
            <FaArrowRight className="transition-transform group-hover:translate-x-1" />
          </a>
        </>
      );
    }
  };
  // -------------------------- MAIN ----------------------------
  return (
    <>
      {renderLogged()}
      {renderUnLogged()}
    </>
  );
};
export default ButtonTryPlatform;
